import React from 'react';

import { languageUtils } from '../../utils/languageUtils/languageUtils';
import { languageHooks } from '../languageHooks/languageHooks';
import { routerHooks } from '../routerHooks/routerHooks';

export const entityPathHooks = {
  useEntityPathname() {
    const languageParamRegex = languageHooks.useGetLanguageParamRegex();
    const pathname = routerHooks.usePathName();
    const slashedPathname = languageUtils.getPathWithSlashInTheEnd(pathname);

    return React.useMemo(() => {
      const langRexExp = new RegExp(languageParamRegex);
      const strWithSlash = languageParamRegex
        .split('|')
        .map(el => `^/${el}/`)
        .join('|');
      const slashedLangExp = new RegExp(strWithSlash);
      return slashedPathname.match(slashedLangExp)
        ? slashedPathname.replace(langRexExp, '').slice(1)
        : slashedPathname;
    }, [languageParamRegex, slashedPathname]);
  },
};
